export const getRatingsAverage = (state) => state.total === 0
    ? 0
    : Object.entries(state.breakdown)
        .map(([key, val]) => val * key)
        .reduce((acc, val) => (acc += val), 0) / state.total;
//# sourceMappingURL=ratings-utils.js.map